import script from "./EditTeamPropertiesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTeamPropertiesModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditTeamPropertiesModal.vue?vue&type=style&index=0&id=58a2a6e7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a2a6e7"]])

export default __exports__